var stepsStyleFn = function stepsStyleFn(token) {
  var _ref;
  return _ref = {
    '.ant-steps.ant-steps-label-vertical': {
      '.ant-steps-item-title': {
        fontSize: token.fontSize,
        lineHeight: token.lineHeight
      },
      '.ant-steps-item-content': {
        marginTop: 8
      }
    },
    '.ant-steps .ant-steps-item-finish .ant-steps-item-icon': {
      backgroundColor: token.colorPrimary,
      borderColor: token.colorPrimary,
      '&>.ant-steps-icon': {
        color: token.colorWhite
      }
    }
  }, _ref[".ant-steps-label-vertical:not(.ant-steps-dot) .ant-steps-item-tail"] = {
    padding: '0 24px'
  }, _ref['.ant-steps.ant-steps-small .ant-steps-item-tail'] = {
    top: '12px'
  }, _ref['.ant-steps.ant-steps-dot .ant-steps-item-tail::after'] = {
    height: '1px'
  }, _ref;
};

export { stepsStyleFn };
